<template>
    <div class="h-100 d-flex align-items-center justify-content-center">
        <a class="btn btn-app" @click="getLocation">
            <i class="fas fa-map-marked-alt"></i> Lấy tọa độ
        </a>
    </div>
</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
export default {
    name: "TheGetLocationButton",
    props: {
        modelValueLat: String, // For latitude two-way binding
        modelValueLong: String, // For longitude two-way binding
    },
    emits: ['update:modelValueLat', 'update:modelValueLong'], // Emit events for two-way binding
    methods: {
        async getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        const gpsLat = position.coords.latitude.toString();
                        const gpsLong = position.coords.longitude.toString();

                        // Emit the latitude and longitude updates for two-way binding
                        this.$emit('update:modelValueLat', gpsLat);
                        this.$emit('update:modelValueLong', gpsLong);
                    },
                    error => {
                        if (error.code === error.PERMISSION_DENIED) {
                            alert("Bạn đã từ chối cấp quyền truy cập vị trí.");
                        } else {
                            console.error(error);
                        }
                    }
                );
            } else {
                alert("Trình duyệt hiện tại không hỗ trợ để lấy tọa độ.");
            }
        },
    },
    watch: {
    },
    async mounted() {
    },
}
</script>
<style></style>